module.exports = __webpack_public_path__ + "static/media/comic-section-image.e35e3597.png";